const SvgRightArrowGrey = (props) => {
	return (
		<svg
			width="6"
			height="10"
			viewBox="0 0 6 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.85067 5.00071C5.85067 4.82149 5.78224 4.64229 5.64567 4.50565L1.34585 0.205874C1.07233 -0.067648 0.62886 -0.067648 0.355449 0.205874C0.0820379 0.479285 0.0820379 0.922665 0.355449 1.19621L4.16017 5.00071L0.355582 8.80522C0.0821707 9.07874 0.0821707 9.52208 0.355582 9.79547C0.628993 10.0691 1.07246 10.0691 1.34598 9.79547L5.6458 5.49576C5.7824 5.35906 5.85067 5.17986 5.85067 5.00071Z"
				fill="#999999"
			/>
		</svg>
	);
};

export default SvgRightArrowGrey;
